import React from 'react';
import { withAlert } from 'react-alert';
import { compose } from 'redux';
import UrlParse from 'url-parse';
import Loading from '../../components/loading';
import LabelHelper from '../../helpers/Label';
import GeneralHelper from '../../helpers/general';
import { Row, Table, Space, Badge, Switch, Tag } from 'antd';
import ListLayout from '../../layouts/list-layout';
import _ from 'lodash';

const ENTRY_PER_PAGE = 10000;
class EquipmentControllerStatusListPage extends React.Component {
	state = {
		intervalId: ''
	}

	componentDidMount() {
		this.getEquipments();

		var intervalId = setInterval(this.getEquipments, 15000);
		this.setState({ intervalId });
	}

	componentDidUpdate(prevProps) {
		const { meta: prevMeta, loading: prevLoading } = prevProps.pageProps;
		const { meta, loading } = this.props.pageProps;

		const { crf_id: prevCrfId } = prevProps.drawerReducer;
		const { crf_id: newCrfId } = this.props.drawerReducer;
		// check hall_id / bldg_cde if change to change what the user will see
		if(prevCrfId !== newCrfId) {
			this.setState(this.initialState);
			this.props.resetPage();
			this.getEquipments();
		}

		if(loading) {
			clearInterval(this.state.intervalId);
		} else {
			if(!loading && loading !== prevLoading){
				var intervalId = setInterval(this.getEquipments, 15000);
				this.setState({ intervalId });
			}
		}

		if (meta && meta !== prevMeta) {
			if(meta.code === 200) {
				this.getEquipments();
			}
			const alertOptions = {
				type: meta.code === 200 ? 'success' : 'error',
				...(meta.code === 40399 && { timeout: 0 })
			};
			this.props.alert.show(meta.message, alertOptions);
			this.props.resetMeta();
		}
	}

	componentWillUnmount() {
		clearInterval(this.state.intervalId);
		this.props.resetPage();
	}

	getEquipments = async opts => {
		const { query } = UrlParse(this.props.location.search, true);
		const {
			page,
			limit
		} = opts || {};
		this.props.getEquipments({
			page: page || query.page || 1,
			limit: limit || query.limit || ENTRY_PER_PAGE,
			equipment_controller_status: true
		});
	};

	onChange = (data) => {
		this.props.toggleEquipmentController(data);
	}

	render() {
		const { loading, equipments } = this.props.pageProps;

		const equipmentsSortedByIp = _.orderBy(equipments, ['controller_ip', 'channel'], ['asc', 'asc']);

		const indexes = [];
		let count = 1;
		// eslint-disable-next-line array-callback-return
		equipmentsSortedByIp.map((data, index) => {
			const counter = equipmentsSortedByIp.filter(data => data.controller_ip === equipmentsSortedByIp[index].controller_ip).length;
			const checkIfMatch = equipmentsSortedByIp[index === 0 ? 0 : index - 1].controller_ip === data.controller_ip;

			if(checkIfMatch) {
				// counter = 3;
				if(counter === indexes[index === 0 ? 0 : index - count]) {
					indexes.push(0);
					count+=1;
				} else {
					indexes.push(counter);
					count=1;
				}
			} else {
				indexes.push(counter);
				count=1;
			}

			if(index === equipmentsSortedByIp.length - 1) {
				indexes.push(0);
			}
		});

		const columns = [
			{
				title: 'IP Address',
				key: 'controller_ip',
				dataIndex: 'controller_ip',
				onCell: (val, index) => {
					return {
						rowSpan: indexes[index]
					};
				}
			},
			{
				title: 'Relay Box Channel',
				key: 'channel',
				dataIndex: 'channel',
				align: 'center'
			},
			{
				title: 'Equipment Name',
				key: 'name',
				dataIndex: 'name',
				render: (name) => GeneralHelper.truncateString(name, 75)
			},
			{
				title: 'Status',
				key: 'status',
				render: data => {
					const { status } = data;
					return (
						<Space size="middle">
							<p>
								<Badge
									color={
										status==='enabled' ? 'green' : 'red'}
								/> {LabelHelper.equipmentStatus(status)} </p>
						</Space>
					);
				}
			},
			{
				title: 'Power Status',
				key: 'usage',
				render: data => {
					const { usage } = data;
					return (
						<Space size="middle">
							<Tag
								color={
									usage === 'on' ? 'green' : usage === 'off' ? 'red' : 'grey'}
							> { usage === 'on' ? 'ON' : usage === 'off' ? 'OFF' : 'OFFLINE' } </Tag>
						</Space>
					);
				}
			},
			{
				title: 'Toggle Switch',
				key: 'toggle_switch',
				render: (text, record) =>  {
					return (
						<Switch
							loading={ loading }
							checked={ record.usage === 'on' ? true : false }
							onChange={() => this.onChange({id: record._id, action: record.usage === 'on' ? 'check_out' : 'check_in'})}
							// disabled={ record.usage === 'offline' }
						/>
					);
				}
			}
		];

		return (
			<>
				<div>
					<ListLayout
						title="Equipment Status Overview"
					>
						{ loading && equipmentsSortedByIp.length <= 0 ?
							<Loading /> :
							<>
								<Row
									justify="end"
									style={{ paddingBottom: 10, paddingTop: 10, paddingRight: 12 }}
								>

								</Row>
								<Table
									rowKey={equipment => equipment._id}
									columns={columns}
									dataSource={ equipmentsSortedByIp }
									style={{ width: '100%', marginTop: 5, paddingRight: 20, paddingLeft: 20, paddingBottom: 20 }}
									scroll={{ x: 800 }}
									bordered
									pagination={false}
								/>
							</>
						}
					</ListLayout>
				</div>
				<div className="copyright">
					<p>Copyright &copy; The Hong Kong University of Science and Technology. <em>All rights reserved.</em></p>
				</div>
			</>
		);
	}
}

export default compose(
	withAlert()
)(EquipmentControllerStatusListPage);
